/* unplugin-vue-components disabled */import script from "./SharePop.vue?vue&type=script&setup=true&lang=js"
export * from "./SharePop.vue?vue&type=script&setup=true&lang=js"

import "./SharePop.vue?vue&type=style&index=0&id=26bed1a1&lang=less"

const __exports__ = script;

export default __exports__